// Set by src/middleware.ts with the environment of the deployment that served
// the page, and read by src/env.js in the browser. CJS so src/env.js can
// require it.
module.exports.RENDER_ENV_COOKIE = 'plaid_render_env';
